<div class="attached-register-node-data">
    <div class="results" ng-show="$ctrl.items.result.length > 0">
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th ng-repeat="hdr in $ctrl.items.header track by $index">{{$ctrl.translateHeader(hdr)}}</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat-start="item in $ctrl.items.result track by $index" class="top">
                    <td class="item-remove">
                        <span ng-if="item.isEditable" ng-click="$ctrl.removeItem(item)" class="fa fa-times hover-effects"></span>
                    </td>
                    <td ng-click="$ctrl.viewDetails(item)" ng-repeat="hdr in $ctrl.items.header track by $index"><span ng-bind="item[hdr]"></span></td>
                </tr>
                <tr ng-repeat-end class="bottom">
                    <td></td>
                    <td colspan="{{$ctrl.items.header.length}}" ng-if="item.info">
                        <div class="additional-info">{{item.info}}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>